import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';
import Modal from '../../../components/Utils/ModalShow';
import EmployeeListModal from './EmployeeListModal';

const PayslipConfirmModal = ({
    isOpen,
    onClose,
    title,
    subtitle,
    headerIcon,
    employeesToShow,
    modalSelectedEmployees,
    setModalSelectedEmployees,
    selectedCount,
    totalCount,
    handleConfirm,
    confirmAction,
    manualCc,
    setManualCc,
    isLoading
}) => {
    const { t } = useTranslation();
    return (
    <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        subtitle={subtitle}
        headerIcon={headerIcon}
        size={800}
        footer={
            <>
                <button
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium"
                    onClick={onClose}
                >
                    {t('basePrimeForm.cancel')}
                </button>
                <button
                    className="px-6 py-2 bg-[--color-primary] hover:bg-[--bg-hover] text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                    onClick={handleConfirm}
                    disabled={selectedCount === 0 || isLoading}
                >
                    {isLoading ? (
                        <span className="loading loading-spinner loading-sm"></span>
                    ) : (
                        <FaCheck size={14} />
                    )}
                    {t('payslipConfirmModal.confirmCount', { count: selectedCount })}
                </button>
            </>
        }
    >
        <div className="p-6 border-b border-gray-200 flex-shrink-0">
            <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                    {t('payslipConfirmModal.selectedOf', { selected: selectedCount, total: totalCount })}
                </div>
                <div className="flex gap-2">
                    <button
                        className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                        onClick={() => setModalSelectedEmployees(employeesToShow)}
                        type="button"
                    >
                        {t('payslipConfirmModal.selectAll')}
                    </button>
                    <button
                        className="px-3 py-1.5 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
                        onClick={() => setModalSelectedEmployees([])}
                        type="button"
                    >
                        {t('payslipConfirmModal.deselectAll')}
                    </button>
                </div>
            </div>
            {confirmAction === 'send' && (
                <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        {t('payslipConfirmModal.ccLabel')}
                    </label>
                    <input
                        type="text"
                        value={manualCc}
                        onChange={(e) => setManualCc(e.target.value)}
                        placeholder="manager@yros.io, rh@yros.io"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[--color-primary]"
                    />
                </div>
            )}
        </div>
        <EmployeeListModal
            employees={employeesToShow}
            selectedEmployees={modalSelectedEmployees}
            setSelectedEmployees={setModalSelectedEmployees}
        />
    </Modal>
    );
};

export default PayslipConfirmModal;
